import http from "../../http-common";
import authHeader from "../../services/authHeader";
import { CANDIDATE_API } from "../../api";


export const filterCandidate = (data) => {
    console.log('calling')
    return http.post(`${CANDIDATE_API}/filter/get`, data, {
        headers: authHeader(),
    });
}
    